// context/AuthContext.js
import { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [messageFromServer, setMessageFromServer] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  // Check authentication status on initial load
  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = async () => {
    try {
      const token = localStorage.getItem('token');
      const userTypeAuth = localStorage.getItem('userTypeAuth');
      if (!token) {
        //logout();
        return;
      }
      
console.log("Auth headers am sending: UserType : ", userTypeAuth, " and Token is : ", token);
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/index.php`, {
        headers: { Authorization: `Bearer ${token}`,  UserTypeAuth: `${userTypeAuth}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
    withCredentials: false
        //headers: { UserTypeAuth: `${userTypeAuth}` }
      });
      //console.log("Data Recived In Auth.js = ", response.data);
      if (response.data.success) {
        setUser(response.data.user);
        //console.log("User In Auth.js = ", response.data.user);
        //navigate('/Dashboard');
      } else {
        //logout();
      }
    } catch (error) {
      console.error("Authentication check failed:", error);
      //logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (credentials) => {
    console.log("credentials am sending in - auth", credentials);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/index.php`,
        { credentials }
      );
      console.log("what am getting from server - Auth", response.data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Login failed');
      }
      //else{
      
      // Store token and validate immediately
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('userTypeAuth', response.data.userTypeAuth);
      localStorage.setItem('userID', response.data.user.id);
      localStorage.setItem('services', response.data);

      localStorage.setItem('userData', JSON.stringify({
        token: response.data.token,
        userTypeAuth: response.data.userTypeAuth,
        user: response.data.user,
        services: response.data.services,
        id: response.data.services.id
    }));

      //await checkAuthStatus(); // Critical: Wait for auth verification
      //navigate('/Dashboard');
    //}
    if (response.data.success) {
    setUser(response.data.user);
    }
      return response;
    } catch (error) {
      console.error("Check Internet Connection, Login failed:", error);
      //logout();
      throw error;
    }
  };

  const userServicesCheckExistingUser = async (email) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/index.php`,
        { 'email' : email, 'apiType' : 'userServicesCheckExistingUser' }
      );
      
     /* if (!response.data.success) {
        throw new Error(response.data.message || 'Check failed');
      } */
     return response;
    } catch (error) {
      console.error("Check failed:", error);
      //logout();
      throw error;
    }
  };

  const userServicesUpload = async (formData) => {
    console.log('formData am sending', formData);
    
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/index.php`,
        { formData, 'apiType' : 'userServicesUpload' }
      );
      return response;
    } catch (error) {
      console.error("Check failed:", error);
      throw error;
    }
  };

  const submitQuestionnaire = async (formData) => {
    console.log('formData am sending', formData);
    //return;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/index.php`,
        { formData}
      );
      console.log("WHat AM Getting From Database in Auth: ", response.data);
      return response;
    } catch (error) {
      console.log(error);
      console.error("Check failed:", error);
      throw error;
    }
  };

  const getQuestionnaire = async (formData) => {
    console.log('formData am sending', formData);
    //return;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/index.php`,
        { formData}
      );
      return response;
    } catch (error) {
      console.error("Check failed:", error);
      throw error;
    }
  };
  
  const userRegistration = async (formData) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/index.php`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      console.log("What Am receiving from Database from User Registration = ", response.data);
      if (!response.data.success) {
        throw new Error(response.data.message || 'Registration failed');
      }
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Registration failed');
    }
  };

  const createClass = async (formData) => {    
    //console.log("formData am sending", formData);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/index.php`,
        { formData, "apiType": 'createClass' }
      );
      //console.log("what am getting from server - Auth", response.data);
      if (!response.data.success) {
        alert(response.data.message);
        throw new Error(response.data.message || 'Class Registration failed');        
      }
      alert(response.data.message)
      return response.data;
    } catch (error) {
      //alert("Error from Database");
      //logout();
      throw error;
    }
  };

  const assignSubjectsToClass = async (formData) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/index.php`,
        { formData, "apiType": 'assignSubjectsToClass' }
      );
      //console.log("what am getting from server - Auth", response.data);
      if (!response.data.success) {
        alert(response.data.message);
        throw new Error(response.data.message || 'Class Registration failed');        
      }
      alert(response.data.message)
      return response.data;
    } catch (error) {
      //alert("Error from Database");
      throw error;
    }
  };

  const postGradesToRegister = async (formData) => {
    //console.log("what am Setting T server - Auth", formData);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/index.php`,
        { formData, "apiType": 'postGradesToRegister' }
      );
      //console.log("what am getting from server - Auth", response.data);
      if (!response.data.success) {
        throw new Error(response.data.message || 'Setting Grades failed');
      }      
      setMessageFromServer(response.data);
      //if (response.data.inserted > 0 && response.data.skipped){
      alert(response.data.message)
      //}
      return response.data.message;
    } catch (error) {
      console.error("Error from Database In Auth - :", error);
      //logout();
      throw error;
    }
  };

  const postSubjectsToRegister = async (formData) => {
    console.log("what am Setting T server - Auth", formData);
    
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/index.php`,
        { formData, "apiType": 'postSubjectsToRegister' }
      );
      console.log("what am getting from server - Auth", response.data);
      if (!response.data.success) {
        alert(response.data.message || 'Setting subjects failed');
        throw new Error(response.data.message || 'Setting subjects failed');
      }      
      setMessageFromServer(response.data);
      //if (response.data.inserted > 0 && response.data.skipped){
      console.log(response.data.message)
      //}
      //return response.data.message;
      alert(response.data.message);
    } catch (error) {
      console.error("Error from Database In Auth - :", error);
      alert("Error from Database");
      //logout();
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userTypeAuth');
    setUser(null);
    setLoading(false);
    navigate('/');
  };

  return (
    <AuthContext.Provider value={{ 
      user,
      messageFromServer,
      loading, 
      login,
      userServicesCheckExistingUser,
      userServicesUpload,
      submitQuestionnaire,
      getQuestionnaire,
      userRegistration, 
      logout,
      checkAuthStatus, // Added for potential future use
      postGradesToRegister,
      postSubjectsToRegister,
      createClass,
      assignSubjectsToClass
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);